module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-order-guess"
  }, [_c('div', {
    staticClass: "guess-tip"
  }, [_c('div', {
    staticClass: "tip-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/security.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('guess_tip1')))])]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/24_hours.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('guess_tip2')))])]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/48hour.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('guess_tip3')))])]), _vm._v(" "), _c('div', {
    staticClass: "tip-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/14_days.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('guess_tip4')))])])]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Guess_you_like')))]), _vm._v(" "), _c('div', {
    staticClass: "guess-lists"
  }, _vm._l((_vm.guessList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "guess-cell",
      class: {
        clear: index == 2
      }
    }, [_c('h3', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-banner"
    }, [_c('img', {
      attrs: {
        "src": item.goods_img
      },
      on: {
        "click": function($event) {
          _vm.more(item.goods_alias, item.goods_id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "guess-order-group"
    }, [_c('div', {
      staticClass: "guess-price"
    }, [_c('p', {
      staticClass: "originalPrice"
    }, [_vm._v(_vm._s(item.goods_unit) + _vm._s(item.market_price))]), _vm._v(" "), _c('p', {
      staticClass: "newPrice"
    }, [_vm._v(_vm._s(item.goods_unit) + _vm._s(item.goods_price))])]), _vm._v(" "), _c('div', {
      staticClass: "guess-buy"
    }, [_c('p', [_c('Button', {
      staticClass: "buy-now",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.buyNow(item.goods_id, item.store_count)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t('buy_now')) + "\n                        ")])], 1), _vm._v(" "), _c('p', [_c('Button', {
      staticClass: "buy-more",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.more(item.goods_alias, item.goods_id)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t('more')) + "\n                            "), _c('Icon', {
      attrs: {
        "type": "chevron-right"
      }
    })], 1)], 1)])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "guess-lists2"
  }, _vm._l((_vm.guessList), function(item, index) {
    return _c('div', {
      staticClass: "guess-cell"
    }, [_c('h3', {
      staticClass: "goods-title"
    }, [_vm._v(_vm._s(item.goods_name))]), _vm._v(" "), _c('div', {
      staticClass: "goods-banner"
    }, [_c('img', {
      attrs: {
        "src": item.goods_img
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "guess-order-group"
    }, [_c('div', {
      staticClass: "guess-price"
    }, [_c('p', {
      staticClass: "newPrice"
    }, [_vm._v(_vm._s(item.goods_unit) + _vm._s(item.goods_price))])]), _vm._v(" "), _c('div', {
      staticClass: "guess-buy"
    }, [_c('p', [_c('Button', {
      staticClass: "buy-now",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          _vm.buyNow(item.goods_id, item.store_count)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t('buy_now')) + "\n                        ")])], 1), _vm._v(" "), _c('p', [_c('Button', {
      staticClass: "buy-more",
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.more(item.goods_alias, item.goods_id)
        }
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t('more')) + "\n                            "), _c('Icon', {
      attrs: {
        "type": "chevron-right"
      }
    })], 1)], 1)])])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "guess-refresh",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.refreshGoods
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Guess_you_like_refresh')) + "\n        "), _c('Icon', {
    attrs: {
      "type": "android-refresh"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c91d0984","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Common/Guess.vue
// module id = 851
// module chunks = 0